"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoryEInstantGrouped = void 0;
const HistoryEInstantsGroupedList_1 = require("./HistoryEInstantsGroupedList");
class HistoryEInstantGrouped {
    constructor(data) {
        this.gameId = data.gameId;
        this.gameName = data.gameName;
        this.gameAmount = data.gameAmount;
        this.transactionDate = data.transactionDate;
        this.gameImageUrl = data.gameImageUrl;
    }
}
exports.HistoryEInstantGrouped = HistoryEInstantGrouped;
HistoryEInstantGrouped.JsonToEInstantsGrouped = (data) => {
    const einstantsList = new HistoryEInstantsGroupedList_1.HistoryEInstantsGroupedList();
    data.forEach(einstantGrouped => einstantsList.push(HistoryEInstantGrouped.JsonToEInstantGrouped(einstantGrouped)));
    return einstantsList.getTransactionDateSorted();
};
HistoryEInstantGrouped.JsonToEInstantGrouped = (data) => new HistoryEInstantGrouped(data);
//# sourceMappingURL=HistoryEInstantGrouped.js.map